import TypingText from './TypingText';

export default TypingText;